<template>
    <main class="layout__main--no-top-padding layout__main">
        <article v-if="!error">
            <transition name="fade">
                <BaseSection
                    v-if="!pending && page"
                    class="container-narrow-left"
                >
                    <h1>{{ page.title }}</h1>

                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-if="page.introText"
                        class="lead"
                        data-allow-anchor
                        v-html="page.introText"
                    />
                    <!-- eslint-enable vue/no-v-html -->
                </BaseSection>
            </transition>
            <PressReleases />
        </article>
    </main>
</template>

<script setup>
import PressReleasesPageQuery from '~/graphql/queries/PressReleasesPage.graphql';

const { activeSite, variables } = useMultisite();
const response = await useLazyAsyncQuery({
    query: PressReleasesPageQuery,
    variables
});

const {
    craftEntry: page,
    pending,
    error,
} = usePageQuery(
    response,
    {
        entryKey: 'pressReleasesPage',
        seoTitle: 'Press Releases',
        seoDescription: 'Get an overview of all the EAU Uroweb Press releases',
        activeSite
    }
);
</script>
